module.exports = __webpack_public_path__ + "img/clear_way.625f2.png";